export default function CancellationPolicy({ size = 64, color = 'white' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.2083 16.0463V9M44.9345 16.0463V9M53.625 17.2193V45.4836C53.625 48.7973 50.9387 51.4836 47.625 51.4836H20.5179C17.2041 51.4836 14.5179 48.7973 14.5179 45.4836V44.9658M53.625 17.2193C53.625 26.2617 51.6092 35.1905 47.7242 43.3559L47.2158 44.4226C47.0136 44.7596 46.6494 44.9658 46.2565 44.9658H8.44242C8.19808 44.9658 8 44.7677 8 44.5233C8 44.457 8.0149 44.3916 8.04361 44.3318L8.52795 43.3233C12.4709 35.1081 14.5179 26.1122 14.5179 16.9998C14.5179 14.4464 16.5878 12.3765 19.1412 12.3765H48.7822C51.4568 12.3765 53.625 14.5447 53.625 17.2193Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M32.25 37.5C37.3586 37.5 41.5 33.3586 41.5 28.25C41.5 23.1414 37.3586 19 32.25 19C27.1414 19 23 23.1414 23 28.25C23 33.3586 27.1414 37.5 32.25 37.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M29.125 25.125L35.375 31.375M35.375 25.125L29.125 31.375"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
